<template>
  <WidgetPanel>
    <template #header>
      <h3 class="text-lg leading-6 font-medium text-gray-900">
        Passende Methoden
      </h3>
    </template>
    <template #default>
      <div v-if="empty" class="divide-y divide-gray-200">
        <div class="block hover:bg-gray-50">
          <div class="min-w-0 flex-1 flex items-center">
            <div class="flex items-center px-4 py-4 sm:px-6">
              <div class="min-w-0 flex-1 flex items-center">
                <p class="text-sm font-medium text-gray-600 truncate">
                  Bisher hast du noch keine Empfehlungen.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul role="list" class="divide-y divide-gray-200">
        <SimilaritiesWidgetItem v-for="similarity in records" :key="similarity.id" :similarity="similarity" as="li" />
      </ul>
    </template>
  </WidgetPanel>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue';
import { useFetchResources } from '@/client/actions';

const props = defineProps({practice: Object});

const parent = computed(() => props.practice.id);
const target = computed(() => '/api/practices/' + parent.value + '/similarities');

const { results, fetch, empty } = useFetchResources(target);

const records = computed(() => results.value.slice(0,3));

const mounted = onMounted(fetch);
const watcher = watch(parent, fetch);
</script>

